import { IconButton } from "@mui/material";
import Divider from "@mui/material/Divider";
import Menu, { MenuProps } from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { styled, alpha } from "@mui/material/styles";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import MenuItemComponent from "./MenuItemComponent";
// import { MENU_ITEMS, MenuItemObjectType } from "./MenuType";
import { MENU_ITEMS, MenuItemObjectType } from "./MenuType";
import Account_circle from "@/assets/account_circle.svg";
import organiImage from "@/assets/organiImage.svg";
import Vector from "@/assets/Vector.png";
import { logout } from "@/redux/slices/auth";
import { getCompanyInfo } from "@/redux/organization/selector";
import Loader from "@/components/Loader";
import { getUserInfo } from "@/redux/user/selector";
import { useTranslation } from "react-i18next";

const StyledMenu = styled((props: MenuProps) => (
	<Menu
		elevation={0}
		anchorOrigin={{
			vertical: "bottom",
			horizontal: "right",
		}}
		transformOrigin={{
			vertical: "top",
			horizontal: "right",
		}}
		{...props}
	/>
))(({ theme }) => ({
	"& .MuiPaper-root": {
		borderRadius: 6,
		marginTop: theme.spacing(1),
		minWidth: 180,
		color:
			theme.palette.mode === "light" ? "rgb(55, 65, 81)" : theme.palette.grey[300],
		boxShadow:
			"rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
		"& .MuiMenu-list": {
			padding: "4px 0",
		},
		"& .MuiMenuItem-root": {
			"& .MuiSvgIcon-root": {
				fontSize: 18,
				color: theme.palette.text.secondary,
				marginRight: theme.spacing(1.5),
			},
			"&:active": {
				backgroundColor: alpha(
					theme.palette.primary.main,
					theme.palette.action.selectedOpacity,
				),
			},
		},
	},
}));

function AvatarComponent() {
	const dispatch = useDispatch();
	const history = useHistory();
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const companyInfo = useSelector(getCompanyInfo);
	const userInfo = useSelector(getUserInfo);
	const { t, i18n } = useTranslation();
	const [menuItemList, setMenuItemList] = React.useState(
		MENU_ITEMS[i18n.language === "ko" ? 0 : 1],
	);

	React.useEffect(() => {
		const handleLanguageChange = () => {
			switch (i18n.language) {
				case "ko":
					setMenuItemList(MENU_ITEMS[0]);
					break;
				case "en":
					setMenuItemList(MENU_ITEMS[1]);
					break;
				default:
					setMenuItemList(MENU_ITEMS[0]);
			}
			// 여기에서 언어 변경에 따른 특정 작업을 수행할 수 있습니다.
		};
		i18n.on("languageChanged", handleLanguageChange);
		return () => {
			i18n.off("languageChanged", handleLanguageChange);
		};
	}, [i18n]);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const socialLogout = () => {
		if (window.gapi) {
			const auth2 = window.gapi.auth2.getAuthInstance();
			if (auth2 !== null) {
				auth2
					.signOut()
					.then(auth2.disconnect())
					.catch((e: any) => {
						console.log(e);
					});
			}
		}
	};
	const handleLogout = () => {
		try {
			handleClose();
			dispatch(logout());
			socialLogout();
			history.push("/auth/login");
		} catch (error) {
			console.error(error);
		}
	};

	if (!companyInfo) {
		return <Loader />;
	}

	return (
		<div>
			<IconButton onClick={handleClick}>
				<img
					src={Vector}
					alt="사진없음"
					style={{
						width: "2rem",
						cursor: "pointer",
					}}
				/>
			</IconButton>
			<StyledMenu
				id="demo-customized-menu"
				MenuListProps={{
					"aria-labelledby": "demo-customized-button",
				}}
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
			>
				<MenuItem onClick={handleClose} disableRipple>
					<div
						style={{
							padding: "0.7rem 0.7rem 0.4rem 0.7rem",
							borderRadius: "12px",
							backgroundColor: "#5b7b9b",
							display: "inline-block",
						}}
					>
						<img src={organiImage} alt="사진없음" />
					</div>
					<div style={{ padding: "1rem" }}>
						<h3
							style={{
								maxWidth: "12rem",
								whiteSpace: "nowrap",
								overflow: "hidden",
								textOverflow: "ellipsis",
							}}
						>
							{companyInfo.name}
						</h3>
						<span>{companyInfo.appCount}개의 어플리케이션</span>
					</div>
				</MenuItem>
				{menuItemList.organization.map(
					(value: MenuItemObjectType, index: number) => {
						return (
							<MenuItemComponent
								key={index}
								value={value}
								handleClose={handleClose}
							/>
						);
					},
				)}
				<Divider sx={{ my: 0.5 }} />
				<MenuItem onClick={handleClose} disableRipple>
					<img
						src={Account_circle}
						alt="이미지없음"
						style={{ width: "4rem" }}
					/>

					<div style={{ padding: "1rem" }}>
						<h3>
							{i18n.language === "ko" && (
								<>
									{userInfo?.nameLast}
									{userInfo?.nameFirst}
								</>
							)}
							{i18n.language === "en" && (
								<>
									{userInfo?.nameFirst} {userInfo?.nameLast}
								</>
							)}
						</h3>
						<div
							style={{
								fontSize: "15px",
								color: "#777",
								maxWidth: "12rem",
								whiteSpace: "nowrap",
								overflow: "hidden",
								textOverflow: "ellipsis",
							}}
						>
							{userInfo?.email || ""}
						</div>
					</div>
				</MenuItem>
				{menuItemList.account.map((value: MenuItemObjectType, index: number) => {
					return (
						<MenuItemComponent
							key={index}
							value={value}
							handleClose={handleClose}
						/>
					);
				})}
				<Divider sx={{ my: 0.5 }} />
				<MenuItem onClick={handleLogout} disableRipple>
					<span style={{ color: "#FF0000" }}>{t("menu.logout")}</span>
				</MenuItem>
			</StyledMenu>
		</div>
	);
}

export default AvatarComponent;
